<template>
    <nav class="sb-topnav navbar navbar-expand navbar-dark bg-dark">
        <router-link class="navbar-brand mr-1 text-left" :to="{name: 'home'}">
            <img src="http://joincloud.com.br/logo.png" alt="Logo" id="jt-logo" />
            Gestor Board
        </router-link>
        <div class="navbar-nav ml-auto" id="header-navbar" >
            <ul class="navbar-nav" >
                <li class="nav-item d-none d-md-inline">
                    <a  
                        href="#" @click.prevent="toggleMenu()"
                        class="nav-link btn btn-link btn-sm text-white order-1 order-sm-0 text-decoration-none"
                    >
                        <font-awesome-icon icon="bars" />
                        <span class="d-none d-md-inline" >
                            Menu
                        </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" id="userDropdown">
                        <font-awesome-icon icon="user-circle" />
                        <span class="d-none d-md-inline" >
                            {{userName}} 
                        </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" @click.prevent="logout()" href="#">
                        <font-awesome-icon icon="sign-in-alt" />
                        <span class="d-none d-md-inline" >
                            Sair
                        </span>
                    </a>
                </li>
                <li class="nav-item d-inline d-md-none">
                    <a  
                        href="#" @click.prevent="toggleMenu()"
                        class="nav-link btn btn-link btn-sm text-white order-1 order-sm-0 text-decoration-none"
                    >
                        <font-awesome-icon icon="bars" />
                        <span class="d-none d-md-inline" >
                            Menu
                        </span>
                    </a>
                </li>
            </ul>
        </div> 
    </nav>
</template>
<script>
export default {
    name: 'menuHeader',
    data(){
        return {

        }
    },
    computed: {
        logged(){
            return this.$store.state.logged
        },
        userName(){
            return this.$store.getters.getUserName
        }
    },
    methods: {
        logout: function(){
            this.$removeItem('gestor-board').then(response => {
                this.$store.commit('logout')
                this.$router.go({name: 'login'})
            })
        },

        toggleMenu: function(){
            let menu = document.getElementById('app-body')
            menu.classList.toggle('sb-sidenav-toggled')
        }
    }   
}
</script>
<style scoped>
    #header-navbar{
        width: 100%;
        margin: 0 !important;
    }

    #header-navbar ul{
        /* flex-direction: row; */
        margin: auto;
        justify-content: space-between;
        width: 100%;
    }
        /* #header-navbar .nav-item{
            padding-left: 0.5rem;
            padding-right: 0.5rem;
        } */

    @media (max-width: 767px){
        #header-navbar ul{
            margin: auto;
            width: 100%;
            justify-content: right;
        }   
    }

    #jt-logo{
        height: 40px;
        width: auto;
    }
</style>